import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Wallet02 = function Wallet02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16 7.9998V4.5005c0-.8318 0-1.2476-.1752-1.5032a1 1 0 0 0-.657-.4204c-.3055-.052-.6831.1223-1.4383.4709L4.859 7.1418c-.6735.3109-1.0103.4663-1.2569.7073a2 2 0 0 0-.4866.7606C3 8.9347 3 9.3055 3 10.0473v4.9525m13.5-.5h.01M3 11.1998v6.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874.4278.218.9879.218 2.108.218h11.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.4278.218-.9879.218-2.108v-6.6c0-1.1201 0-1.6801-.218-2.108a2 2 0 0 0-.874-.874c-.4278-.218-.9879-.218-2.108-.218H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 9.5198 3 10.0798 3 11.1999m14 3.3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    })
  }));
};
export default Wallet02;